import React from 'react'
import { useLanguage } from '../../hooks/useLanguage'
import { Language } from './translations'

interface LanguageSelectorProps {
  openUpwards?: boolean;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ openUpwards = false }) => {
  const { language, setLanguage } = useLanguage()

  const handleLanguageChange = (newLanguage: Language) => {
    setLanguage(newLanguage)
  }

  // Funzione per ottenere la bandiera in base alla lingua
  const getFlag = (lang: Language) => {
    switch (lang) {
      case 'en':
        return '🇬🇧'
      case 'it':
        return '🇮🇹'
      case 'nl':
        return '🇳🇱'
      default:
        return '🌍'
    }
  }

  return (
    <div className="language-selector relative flex items-center">
      <select
        value={language}
        onChange={(e) => handleLanguageChange(e.target.value as Language)}
        className={`bg-transparent text-white border border-white rounded px-3 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-yellow-300 flex items-center ${
          openUpwards ? 'transform -translate-y-1' : ''
        }`}
        style={{ 
          backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%23ffffff' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e")`,
          backgroundPosition: 'right 0.5rem center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: '1.5em 1.5em',
          paddingRight: '2rem'
        }}
      >
        <option value="en">🇬🇧 EN</option>
        <option value="it">🇮🇹 IT</option>
        <option value="nl">🇳🇱 NL</option>
      </select>
    </div>
  )
}

export default LanguageSelector 